<template>
    <div class="smiley-popup">
        <div v-if="data.correctPSAnswer">
                <div class="popup-title-practice">
                    <div class="Congratulations green-popup">Congratulations!</div>
                    <div class="Congratulations green-popup">Your answer is <b class="green-popup">CORRECT</b></div>
                </div>
                <div class="smiley-img"><img src="@/assets/img/CorrectAnsBelowAvgTimeSmiley.svg"/></div>
                <div class="flag-text-row">
                    <div class="avg-time">Avg Time: <span>{{data.question_average_time}}</span></div>
                    <div class="avg-time">Your Time: <span>{{data.question_time_spent}}</span></div>
                </div>
                <div class="impact-center">Impact on Topic health: {{data && data.topic_health_change > 0 ? '+'+data.topic_health_change : data.topic_health_change}}%
                    <img v-if="data && data.topic_health_change >= 0" src="@/assets/img/UpArrowGreen.svg"/>
                    <img v-else-if="data && data.topic_health_change < 0" src="@/assets/img/DownArrowRed.svg"/>
                </div>
                <div v-if="data.question_time_spent < (1/5)*(data.question_average_time)" class="flag-text-row">
                    <div class="flag-img"><img src="@/assets/img/FlagForCorrectAnsBelowAvgTime.svg"/></div>
                    <div class="Health-text">
                        <div class="green-popup">That was lightning quick.</div>
                        <div class="green-popup">Are you sure you haven't seen the question before or just got lucky?</div>
                    </div>
                </div>
                <div class="block-bold">Enhance your understanding  by going through the detailed solution.</div>
                <div class="smiley-popup-btn">
                                        <v-btn class="cust-btn red-btn" @click="onClose({status: false, callNextQuestion: true})">Next Question</v-btn>
                    <!-- <v-btn class="cust-btn gray-btn" @click="onClose({status: false, callNextQuestion: true})">Next Question</v-btn> -->
                    <v-btn class="cust-btn green-btn" @click="onClose({status: false, showSolution: true})">Show Solution</v-btn>
                </div>
        </div>
        <div v-else-if="data.incorrectPSAnswer">
                <div class="popup-title-practice">
                    <div class="Congratulations red-popup">Sorry!</div>
                    <div class="Congratulations red-popup">Your answer is <b class="red-popup">INCORRECT</b></div>
                </div>
                <div class="smiley-img"><img src="@/assets/img/IncorrectAnsSmiley.svg"/></div>
                <div class="flag-text-row">
                    <div class="avg-time">Avg Time: <span>{{data.question_average_time}} sec.</span></div>
                    <div class="avg-time">Your Time: <span>{{data.question_time_spent}} sec.</span></div>
                </div>
                <div class="impact-center">Impact on Topic health: {{data && data.topic_health_change > 0 ? '+'+data.topic_health_change : data.topic_health_change}}%
                    <img v-if="data && data.topic_health_change > 0" src="@/assets/img/UpArrowGreen.svg"/>
                    <img v-else-if="data && data.topic_health_change <= 0" src="@/assets/img/DownArrowRed.svg"/>
                </div>
                <div v-if="data.question_time_spent < (1/8)*(data.question_average_time)" class="flag-text-row">
                    <div class="flag-img"><img src="@/assets/img/FlagForIncorrectAnswer.svg"/></div>
                    <div class="Health-text">
                        <div class="red-popup">Your time spent was less than the average time needed to get this question correct.</div>
                        <div class="red-popup">Remember that accuracy is more important than speed.</div>
                    </div>
                </div>
                <div class="block-bold">Checkout the ideal way to approach this question by going through the detailed solution.</div>
                <div class="smiley-popup-btn">
                    <v-btn class="cust-btn red-btn" @click="onClose({status: false, callNextQuestion: true})">Next Question</v-btn>
                    <v-btn class="cust-btn green-btn" @click="onClose({status: false, showSolution: true})">Show Solution</v-btn>
                </div>
        </div>
        <div v-else-if="data.noPSAnswer && !data.endRetryShortlisted">
                <div class="popup-title-practice yellow-popup">We didn't receive any response.</div>
                <div class="smiley-img"><img src="@/assets/img/NoResponseSmiley.svg"/></div>
                <div class="impact-center bold-red">Are you sure you want to give up?<img src="@/assets/img/GiveUpSmiley.svg"/></div>
                <div class="flag-text-row">  
                    <div class="flag-img"><img src="@/assets/img/FlagForNoResponse.svg"/></div>
                    <div class="Health-text">
                        <div class="yellow-popup">You can go back and try harder to solve this question or go through the solution to</div> 
                        <div class="yellow-popup">learn to solve this type of question</div>
                    </div>
                </div>
                <div class="smiley-popup-btn">
                    <v-btn class="cust-btn red-btn" @click="onClose({status: false, callNextQuestion: true})">Next Question</v-btn>
                    <v-btn class="cust-btn green-btn" @click="onClose({status: false, showSolution: true})">Show Solution</v-btn>
                    <v-btn class="cust-btn blue-btn" @click="onClose({status: false})">Go Back</v-btn>
                </div>
        </div>
        <div v-else-if="data.avgTimeOver">
                <div class="Health-text">
                    <div class="bold-yellow">The time you have spent on this question has exceeded the average</div>
                    <div class="bold-yellow">time in which students answer this question correctly</div>
                </div>
                <div class="smiley-img marks-top"><img src="@/assets/img/AvgTimeExceededSmiley.svg"/></div>
                <div class="block-bold">Why don't you look at one of the Hints to get some guidance!</div>
        </div>
         <div v-else-if="data.outOfQuestions && (data.endCustomSession || data.endRetryShortlisted)">
                <div class="Health-text"><br>
                    <div v-if="data.endCustomSession && !data.endRetryShortlisted" class="green-popup">Custom Improvement Assignment Completed</div>
                    <div v-else-if="data.endRetryShortlisted && !data.endCustomSession" class="green-popup">You have completed Retrying all Shortlisted Questions</div>
                    <div class="green-popup">{{data.totalSessionDuration}}</div>
                </div>
                <div class="smiley-img marks-top"><img src="@/assets/img/EndSessionSmiley.svg"/></div>
                <div class="text-center">
                    <v-btn color="primary" class="cust-btn practice-session-btns" @click="onClose({status: false, endSession: true})">Okay</v-btn>
                </div>
        </div>
        <div v-else-if="data.endSession">
                <div class="Health-text"><br>
                    <div class="green-popup">Your total Practice Session duration is </div>
                    <div class="green-popup">{{data.totalSessionDuration}}</div>
                </div>
                <div class="smiley-img marks-top"><img src="@/assets/img/EndSessionSmiley.svg"/></div>
                <div class="block-bold">Are you sure you want to end this session?</div>
                <div class="smiley-popup-btn">
                    <v-btn class="cust-btn red-btn" @click="onClose({status: false, endSession: true})">Yes</v-btn>
                    <v-btn class="cust-btn green-btn" @click="onClose({status: false})">No</v-btn>
                </div>
        </div>
        <div v-else-if="data.thatsAll || data.errorMessage==='Well Done !'">
                <div class="Health-text">
                    <!-- <div class="maroon-popup">{{data.errorMessage}}</div> -->
                    <div class="green-popup" :class="data.errorMessage==='Well Done !' ? 'green-popup' : 'maroon-popup'">{{data.errorMessage}}</div>
                </div>
                <!-- <div class="smiley-img marks-top-bottom"><img src="@/assets/img/ThatsAllInTopicSmiley.svg"/></div> -->
                <div v-if="data.errorMessage==='Well Done !'" class="smiley-img marks-top-bottom"><img src="@/assets/img/thumbs_up.png"/></div>
                <div v-else class="smiley-img marks-top-bottom"><img src="@/assets/img/ThatsAllInTopicSmiley.svg"/></div>
                <div class="Health-text">
                    <div v-if="data.errorMessage==='Well Done !'">
                    <div class="green-popup text-align">You are doing great in this Practice Session and your level of preparation in the Topics chosen for this practice session is now adequate for getting a top rank.</div>
                    <div class="green-popup text-align">In order to make optimum use of your time, it is recommended that you start a new practice session with a different set of Topics.</div>
                    <div class="green-popup text-align">You can check the Chapters that you need urgent attention in the "My Health" section.</div>
                    </div>
                    <div v-else-if="data.errorMessage === 'Revise and Try Again'">
                    <div class="green-popup text-align">We are sorry, but your responses seem to indicate that your level of preparation in the chosen topics need a bit more effort.</div>
                    <div class="green-popup text-align">In order to make optimum use of your time, it is recommended that you start a new practice session with a different set of Topics or revise the topics chosen in this Practice Session and Try Again.</div>
                    <div class="green-popup text-align">You can check the Chapters that you need urgent attention in the "My Health" section.</div>
                    </div>
                </div>
                <div class="smiley-popup-btn">
                    <v-btn class="cust-btn red-btn" @click="onClose({status: false, endSession: true})">End Session</v-btn>
                </div>
        </div>
        <div v-else-if="(data.outOfQuestions && data.endRetryShortlisted && data.endCustomSession) || data.errorMessage === 'Revise and Try Again' && !data.thatsAll">
                <div class="Health-text">
                    <div class="maroon-popup">{{data.errorMessage}}</div>
                </div>
                <div class="smiley-img marks-top-bottom"><img src="@/assets/img/OutOfQuestionsSmiley.svg"/></div>
                <div class="Health-text">
                    <div class="green-popup">We suggest you see the concept videos to revise the chapter and give this chapter</div>
                    <div class="green-popup">another shot once you have revised it better.</div>
                </div>
                <div class="smiley-popup-btn">
                    <v-btn class="cust-btn red-btn" @click="onClose({status: false, endSession: true})">End Session</v-btn>
                </div>
        </div>
        
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "PracticeSessionPopUps",
    props: ["data", "onClose"],
    data: function() {
        return {}
    },
    methods: {
        ...mapActions({
            objectQuestion: "resultStore/objectQuestion"
        }),
    }
};
</script>